import { BORDER_STYLES, isBorderStyle, type BorderStyle } from "./border-settings";

export const IMAGE_ALIGN_STORAGE_KEY = "turbonotes2-image-align";
export const IMAGE_BORDER_STORAGE_KEY = "turbonotes2-image-border";

export const IMAGE_ALIGNS = ["left", "center", "right"] as const;
export const IMAGE_BORDERS = BORDER_STYLES;

export type ImageAlign = (typeof IMAGE_ALIGNS)[number];
export type ImageBorder = BorderStyle;

export interface ImageSettings {
  align: ImageAlign;
  border: ImageBorder;
}

export const DEFAULT_IMAGE_SETTINGS: Readonly<ImageSettings> = {
  align: "left",
  border: "none",
};

export const isImageAlign = (value: unknown): value is ImageAlign =>
  IMAGE_ALIGNS.includes(value as ImageAlign);
export const isImageBorder = isBorderStyle;

export function loadImageSettings(storage: Pick<Storage, "getItem">): ImageSettings {
  const align = storage.getItem(IMAGE_ALIGN_STORAGE_KEY);
  const border = storage.getItem(IMAGE_BORDER_STORAGE_KEY);
  return {
    align: isImageAlign(align) ? align : DEFAULT_IMAGE_SETTINGS.align,
    border: isImageBorder(border) ? border : DEFAULT_IMAGE_SETTINGS.border,
  };
}
